
export * from './antdUtils';
export * from './Progress';
export * from './request';
export * from './store';
export * from './RealDOM';
export * from './loadScript';
export * from './logout';
export * from './createMarkdown';
export * from './ReadonlyQS';

export function checkObjectValueUnique<T = {}>(p: T, name: string = 'Object') {
    const keys = Object.values(p);
    const pathArr: string[] = [];
    keys.reduce((pre, cur) => {
        if (pre[cur]) {
            pre[cur]++;
            pathArr.push(cur);
        } else {
            pre[cur] = 1;
        }
        return pre;
    }, {});
    if (pathArr.length > 0) {
        console.error(`${name} 的 value 值存在重复项: ${pathArr.join(', ')}`);
    }
}

export interface ITreeNode extends IPlainObject {
    children: ITreeNode[];
}
export type TEachFn<P = ITreeNode> = (tn: P, level: number) => boolean | undefined | null;

/**
 * 深度优先的节点遍历
 * @param tns
 * @param fn
 * @param level
 * @param childrenKey
 */
export function eachNode<P = ITreeNode>(
    tns: P[], fn: TEachFn<P>, level: number = 0, childrenKey = 'children'
): boolean {
    for (const tn of tns as any) {
        if (fn(tn, level) === true) {
            return true;
        }
        if (tn[childrenKey] && eachNode<P>(tn[childrenKey], fn, level + 1)) {
            return true;
        }
    }
    return false;
}

// 计算字符串字节长度
export function calculateByteLength(str: string): number {
    if (!str) {
        return 0;
    }

    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(str);
    return utf8Bytes.length;
}
